const FIELD_ERROR_ALIASES: Partial<Record<string, string[]>> = {
  zip: ['postcode']
};

/** Removes a changed field's validation error and any backend aliases for it. */
export function removeBillingFieldError(
  errors: Partial<Record<string, string>>,
  field: string
): Partial<Record<string, string>> {
  const fieldsToClear = [field, ...(FIELD_ERROR_ALIASES[field] ?? [])];

  return Object.fromEntries(Object.entries(errors).filter(([name]) => !fieldsToClear.includes(name)));
}
